import React from 'react'
import { logger } from './logger'

const sleep = async ms => new Promise((resolve => setTimeout(resolve, ms)))

const initialState = {
  defaultLocale: '',
  locale: '',
  changeLocale: async () => {
    await sleep(50)
    logger.warn('Should not called that.')
  }
}

const ParametersContext = React.createContext(initialState)

export default ParametersContext
